import React from "react";

export const StaticCard = (props) => {
  return (
    <div className={props.className}>
      <div className="bg-color-promotion color-white border-radius-main">
        <div className="flex-column p-5">
          <span className="text-center">{props.name}</span>
          <span className="text-center font-size-main-4">{props.value}</span>
        </div>
      </div>
    </div>
  );
};
